import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, TraceIdSchema, CorrelationIdSchema } from "../primitives/ids.js";
import { NotificationChannelSchema, NotificationDeliveryEventIdSchema, NotificationTemplateKeySchema, } from "./notification-event.js";
/** PF-007 — notification delivery queue name (BullMQ). */
export const NOTIFICATION_QUEUE_NAME = "tier0-notifications";
export const NOTIFICATION_MAX_ATTEMPTS = 5;
export const NotificationDeliveryJobKindSchema = z.literal("DELIVER_NOTIFICATION");
export const NotificationDeliveryJobPayloadV1Schema = z
    .object({
    schemaVersion: z.literal("notification-delivery-job.v1.0"),
    jobKind: NotificationDeliveryJobKindSchema,
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema.optional(),
    deliveryEventId: NotificationDeliveryEventIdSchema,
    templateKey: NotificationTemplateKeySchema,
    channel: NotificationChannelSchema,
    idempotencyKey: z.string().min(8).max(200),
    attempt: z.number().int().min(1).max(NOTIFICATION_MAX_ATTEMPTS),
    maxAttempts: z.number().int().min(1).max(NOTIFICATION_MAX_ATTEMPTS).default(NOTIFICATION_MAX_ATTEMPTS),
    variables: z.record(z.string(), z.string().max(500)).optional(),
    traceId: TraceIdSchema,
    correlationId: CorrelationIdSchema.optional(),
})
    .strict();
export function notificationEnqueueJobId(agencyId, idempotencyKey) {
    return `notification:${agencyId}:${idempotencyKey}`;
}
//# sourceMappingURL=notification-job-payload.js.map